<template>
    <div class="flex min-h-[62px] w-full items-center justify-between rounded-muval-2 border bg-white p-3">
        <MatchFleetInfo :match="match" />

        <div class="flex items-center gap-x-5">
            <div
                v-if="hasCallOutFee"
                class="flex flex-col md:border-l md:border-black/10 md:py-1 md:pl-4"
            >
                <span class="text-xs font-medium text-muval-gray-3">Call-out fee</span>
                <span class="text-sm font-medium text-muval-gray-1">
                    {{ match.call_out_fee?.formatted }}
                </span>
            </div>

            <div
                v-if="!hasCallOutFee"
                class="h-[41px] w-px bg-black/10"
            />

            <div class="flex flex-col justify-center">
                <span
                    v-if="hasCallOutFee"
                    class="text-xs font-medium text-muval-gray-3"
                    >From</span
                >
                <span class="text-sm font-medium text-black">
                    <template v-if="isVariable"> {{ match.price_per_unit?.formatted }} / 30 mins </template>
                    <template v-else>
                        {{ match.estimated_total?.formatted }}
                    </template>
                </span>
            </div>

            <MuvalButton
                :tertiary="readonly"
                class="font-medium"
                :loading="
                    (!match.isFixed && match.selecting) ||
                    (hasOnlyOneOption && !match.hasOptions && match.selecting) ||
                    (hasOnlyOneOption && match.hasOptions && match.options[0].selecting)
                "
                :icon="readonly ? 'system-check' : ''"
                icon-right
                @click="handleMatchSelect"
                >{{ readonly ? 'Selected' : 'Select' }}</MuvalButton
            >
        </div>
    </div>
</template>
<script setup lang="ts">
import type { MoveJob, MoveMatch } from '@/types';
import { useResultsStore } from '@/store';

const results = useResultsStore();
const router = useRouter();

interface Props {
    match: MoveMatch;
    moveJob?: MoveJob;
    readonly: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    readonly: false,
});

const hasCallOutFee = computed(() => {
    const amount = props.match.call_out_fee?.amount;
    if (!amount) return false;
    return Number(amount) > 0;
});

const hasOnlyOneOption = computed(() => {
    if (props.match?.isLocal) {
        if (props.match?.hasOptions && props.match?.options?.length >= 1) {
            if (props.match?.options?.length > 1) {
                console.log('match has more than one option');
                console.log(props.match?.company?.name);
            }

            return true;
        }
    }

    if (props.match?.hasOptions && props.match?.options?.length > 1) {
        return false;
    } else {
        return true;
    }
});

const canSelectMatch = computed(() => {
    // If the user is on the review page, prevent selecting the match again.
    if (isReviewPage.value || router.currentRoute.value.name === 'Confirmed') {
        return false;
    }

    if (props.match.selecting) {
        return false;
    }

    if (!hasOnlyOneOption.value) {
        return false;
    }

    return true;
});

const isReviewPage = computed(() => {
    return router.currentRoute.value.name === 'Review';
});

const handleMatchSelect = async () => {
    console.log('Can select match', canSelectMatch.value);

    if (!canSelectMatch.value || props.readonly) {
        return;
    }

    if (props.match.hasOptions) {
        console.log('props.match.options[0]');
        results.selectMatch(props.match.options[0]);
    } else {
        console.log('props.match');
        results.selectMatch(props.match);
    }
};

const isVariable = computed(() => {
    return props.match?.pricing_type === 'VARIABLE';
});
</script>
